import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import { Card, CardBody, Col } from 'reactstrap';
import renderSelectField from '../../../shared/components/form/Select';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import validate from './validate';

class InscriptionForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFilterChanges: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    mallas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    semesters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    subjects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    alumnos: PropTypes.arrayOf(PropTypes.shape({})),
    nombreAlumno: PropTypes.string,
    apellidoAlumno: PropTypes.string,
    numeroLegajo: PropTypes.number,
  }

  static defaultProps = {
    submitting: false,
    nombreAlumno: '',
    apellidoAlumno: '',
    numeroLegajo: 0,
    alumnos: [],
  }

  render() {
    const {
      submitting,
      handleSubmit,
      onBack,
      mallas = [],
      semesters = [],
      subjects = [],
      onFilterChanges,
      nombreAlumno,
      apellidoAlumno,
      numeroLegajo,
      alumnos = [],
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <div className="card__title">
                <h5 className="bold-text">Datos de la inscripción</h5>
              </div>
              {numeroLegajo > 0
                && (
                  <div className="form__form-group">
                    <span className="form__form-group-label">Alumno</span>
                    <div className="form__form-group-field">
                      <input
                        value={`${numeroLegajo}: ${nombreAlumno} ${apellidoAlumno}`}
                        disabled
                      />
                    </div>
                  </div>
                )
              }
              {numeroLegajo <= 0 && (
                <div className="form__form-group">
                  <span className="form__form-group-label required">Alumno</span>
                  <div className="form__form-group-field">
                    <Field
                      name="alumno"
                      component={renderSelectField}
                      placeholder="Alumno"
                      autoComplete="false"
                      options={alumnos}
                      onChange={v => onFilterChanges('alumno', 'perfilAlumnoId', v)}
                    />
                  </div>
                </div>
              )}
              <div className="form__form-group">
                <span className="form__form-group-label required">Malla</span>
                <div className="form__form-group-field">
                  <Field
                    name="malla"
                    component={renderSelectField}
                    placeholder="Malla"
                    autoComplete="false"
                    options={mallas}
                    onChange={v => onFilterChanges('malla', 'mallaId', v)}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label required">Semestre</span>
                <div className="form__form-group-field">
                  <Field
                    name="semestre"
                    component={renderSelectField}
                    placeholder="Semestre"
                    autoComplete="false"
                    options={semesters}
                    onChange={v => onFilterChanges('semestre', 'semestreId', v)}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label required">Materia</span>
                <div className="form__form-group-field">
                  <Field
                    name="materia"
                    component={renderSelectField}
                    placeholder="Materia"
                    autoComplete="false"
                    options={subjects}
                  />
                </div>
              </div>

            </Form>
            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const InscriptionFormForm = reduxForm({
  form: 'InscriptionFormForm',
  validate,
  enableReinitialize: true,
})(InscriptionForm);

export default setPropsAsInitialValues(InscriptionFormForm);
